import { pick } from 'lodash-es';
import { parseInput } from './input/input';
import { makeConnected } from '../make-connected';
import { initialConfiguration } from './initial-configuration';
import type { Types } from '../types';
import { CoreMap } from '../../core';
import { structure } from '../types/to';
import { COLLECTION_ID } from './input/util/util';

function transformId (id: string): string {
  // should be interpreted as event id
  const indexOfDot = id.indexOf('.');
  if (indexOfDot == -1) return COLLECTION_ID.events + '.' + id;

  // split on first dot only
  const prefix = id.substring(0, indexOfDot).toLowerCase();
  const suffix = id.substring(indexOfDot + 1);

  if (prefix == COLLECTION_ID.lockedTimes.toLowerCase()) return COLLECTION_ID.lockedTimes + '.' + suffix;
  if (prefix == COLLECTION_ID.events     .toLowerCase()) return COLLECTION_ID.events      + '.' + suffix;

  throw new Error(`(RS::To::transformId) Unknown id prefix "${prefix}" in id "${id}"`);
}

export function schedules (
  data:     Types.toInput,
  _options: Types.toOptions = {}
): Types.toOutput {
  ////
  //// parse the options
  ////
  const options = ((): Types.parsedToOptions => {
    const x = _options.partialScheduleOptions;
    const partialScheduleOptions: Types.parsedToOptions['partialScheduleOptions'] = x
      ? {
        includedEvents:        x.includedEvents    ? new Set(x.includedEvents)    : undefined,
        includedLocations:     x.includedLocations ? new Set(x.includedLocations) : undefined,
        omittedEventsHandling: x.omittedEventsHandling
      }
      : undefined;

    return { ..._options, partialScheduleOptions };
  })();

  ////
  //// for backward compatibility: add default collection to included events set
  ////
  if (options.partialScheduleOptions?.includedEvents?.size) {
    options.partialScheduleOptions.includedEvents = new Set(
      [...options.partialScheduleOptions.includedEvents].map(x => transformId(x))
    );
  }


  // we will work only with connected schedule data
  const connectedData = makeConnected(data);

  return {
    meta: {
      structure: structure,
      division:  pick(connectedData.division, 'displayName', 'start', 'end'),
    },
    algorithmParameters: {
      weights:               options.algorithmWeightParameters,
      computeTimeMultiplier: options.computeTimeMultiplier
    },
    input: parseInput(connectedData, options),
    ...options.appendCoreData && { coreData: CoreMap.to.schedules(data) },
    ...options.appendOutput   && { output: initialConfiguration(connectedData.events, connectedData.lockedTimes, options) },
  };
};